import React from "react";
import { FieldLabel, TextField } from "react-invenio-forms";
import PropTypes from "prop-types";
import { Divider, Grid } from "semantic-ui-react";
import { i18next } from "@translations/up/i18next";

export const RelatedExhibitionField = ({ fieldPath, label }) => {
  return (
    <>
      <FieldLabel htmlFor={fieldPath} label={label} />
      <Divider fitted />
      <Grid padded>
        <Grid.Column width="6">
          <TextField
            fieldPath={`${fieldPath}.name`}
            label={i18next.t("Name")}
            required
          />
        </Grid.Column>
        <Grid.Column width="6">
          <TextField
            fieldPath={`${fieldPath}.venue`}
            label={i18next.t("Venue")}
            required
          />
        </Grid.Column>
        <Grid.Column width="4">
          <TextField
            fieldPath={`${fieldPath}.date`}
            label={i18next.t("Dates")}
            placeholder={i18next.t(
              "YYYY-MM-DD or YYYY-MM-DD/YYYY-MM-DD for intervals. MM and DD are optional."
            )}
            required
          />
        </Grid.Column>
      </Grid>
    </>
  );
};

RelatedExhibitionField.propTypes = {
  fieldPath: PropTypes.string,
  label: PropTypes.string,
};

RelatedExhibitionField.defaultProps = {
  fieldPath: "custom_fields.related_exhibition",
  label: i18next.t("Related exhibition"),
};
